export const isEqual = (a, b) => {
    if (a === b) {
        return true;
    }
    if (a instanceof Array && b instanceof Array) {
        if (a.length !== b.length) {
            return false;
        }
        for (let i = 0; i < a.length; i++) {
            if (!b.includes(a[i]) &&
                b.find(v => isEqual(a[i], v)) === undefined) {
                return false;
            }
        }
    }
    else if (a instanceof Object && b instanceof Object) {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) {
            return false;
        }
        for (let i = 0; i < aKeys.length; i++) {
            const key = aKeys[i];
            if (!isEqual(a[key], b[key])) {
                return false;
            }
        }
    }
    else {
        return false;
    }
    return true;
};
